import { Component } from '@angular/core';

@Component({
    selector: 'gpis-login',
    templateUrl: 'login.html',
    styles: [ '.gpis-error-panel { color: red; padding: 5rem; font-weight: bold; }' ]
})
export class LoginComponent { }


// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/login/login.component.ts